import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps -- only run on load using no deps
const useOnLoad = (f: () => unknown) => useEffect(() => { f(); }, []);

export default useOnLoad;
